module.exports = __webpack_public_path__ + "img/arrk-standard-dark.11517113.svg";